export const DOCUMENT_STATUS = {
    CREATED: 'CREATED',
    PENDING: 'PENDING',
    PENDING_VENDOR_APPROVAL: 'PENDING_VENDOR_APPROVAL',
    PENDING_BD_OPS_APPROVAL: 'PENDING_BD_OPS_APPROVAL',
    FAILED: 'FAILED',
    APPROVED: 'APPROVED',
    VERIFIED: 'VERIFIED',
    REJECTED: 'REJECTED',
    VENDOR_REJECTED: 'VENDOR_REJECTED',
    BD_OPS_REJECTED: 'BD_OPS_REJECTED',
    DUPLICATE_REJECTED: 'DUPLICATE_REJECTED',
};
export const DL_COURT_CASE_STATUS = {
    INITIATED: 'INITIATED',
    VERIFIED: 'VERIFIED',
    INITIATION_FAILED: 'INITIATION_FAILED',
};
export const DOCUMENT_PENDING_STATUS = [
    DOCUMENT_STATUS.PENDING,
    DOCUMENT_STATUS.PENDING_VENDOR_APPROVAL,
    DOCUMENT_STATUS.PENDING_BD_OPS_APPROVAL,
];
export const DOCUMENT_REJECTED_STATUS = [
    DOCUMENT_STATUS.REJECTED,
    DOCUMENT_STATUS.VENDOR_REJECTED,
    DOCUMENT_STATUS.BD_OPS_REJECTED,
    DOCUMENT_STATUS.DUPLICATE_REJECTED,
];
export const DL_COURT_CASE_REJECTED_STATUS = [
    DL_COURT_CASE_STATUS.INITIATION_FAILED,
];
export const DL_COURT_CASE_INITIATION_STATUS = [DL_COURT_CASE_STATUS.INITIATED];
export const DL_COURT_CASE_APPROVED_STATUS = [DL_COURT_CASE_STATUS.VERIFIED];
export const APPROVE_STATUS = [DOCUMENT_STATUS.PENDING_BD_OPS_APPROVAL];
